import { getBanks } from '@/services/banks.service';
import { getLocalities, getProvinces } from '@/services/localities.service';

const Model = {
  namespace: 'userSettings',
  state: {
    city: [],
    banks: [],
    province: [],
    isLoading: false,
    showPasswordModal: false,
  },

  effects: {
    *fetchBanks(_, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });

      const response = yield call(getBanks);
      yield put({
        type: 'setBanks',
        payload: response,
      });
    },

    *fetchProvince(_, { call, put }) {
      yield put({
        type: 'changeLoading',
        payload: true,
      });
      const response = yield call(getProvinces);
      yield put({
        type: 'setProvince',
        payload: response.data,
      });
    },

    *fetchCity({ payload }, { call, put }) {
      const response = yield call(getLocalities, payload);
      yield put({
        type: 'setCity',
        payload: response.data,
      });
    },

    *setPasswordModalVisibility({ payload }, { put }) {
      yield put({
        type: 'setPasswordModalVisibility',
        payload,
      });
    },
  },
  reducers: {
    setProvince(state, action) {
      return { ...state, province: action.payload };
    },

    setBanks(state, action) {
      return { ...state, banks: action.payload };
    },

    setCity(state, action) {
      return { ...state, city: action.payload };
    },

    changeLoading(state, action) {
      return { ...state, isLoading: action.payload };
    },

    setPasswordModalVisibility(state, action) {
      return { ...state, showPasswordModal: action.payload };
    },
  },
};
export default Model;
